import {LocationsNormalization} from './locations-normalization.types';
import {GlobalContainerTypes, inject, Language, Location, LocationResponse} from '@innowise-group/core';
import {injectable} from 'inversify';

@injectable()
class LocationsNormalizationService implements LocationsNormalization {
  public static readonly type = GlobalContainerTypes.LocationsNormalization;
  @inject(GlobalContainerTypes.Language) private language: Language;

  constructor() {
    this.normalizeLocationFromApi = this.normalizeLocationFromApi.bind(this);
  }

  public normalizeLocationFromApi(location: LocationResponse): Location {
    const isRuLanguage = this.language.checkAppLanguage();

    const {country_name, country_name_eng, city, city_eng, country, id} = location;

    const countryName = isRuLanguage ? country_name : country_name_eng;
    const countryNameAltLang = isRuLanguage ? country_name_eng : country_name;
    const cityName = isRuLanguage ? city : city_eng;
    const cityAltLang = isRuLanguage ? city_eng : city;

    return {
      id: id && String(id),
      countryName,
      countryNameAltLang,
      city: cityName,
      cityAltLang,
      country,
    };
  }
}

export default LocationsNormalizationService;
